<form>
  <!-- Modal Header -->
  @if (isDialog == true) {
    <div class="modal-header">
      @if (contactToUpdate == undefined) {
        <h4 class="modal-title">Add Contact</h4>
      }
      @if (contactToUpdate != undefined) {
        <h4 class="modal-title">Edit Contact</h4>
      }
      <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
    </div>
  }

  <div class="modal-body">
    <div class="my-0">
      <div class="group">
        <p class="my-0">Name*</p>
        <input type="text" required class="textInputLong" name="name" [(ngModel)]="name" />
        <span class="highlight"></span>
        <span class="bar barLong"></span>
      </div>
    </div>
    <div class="my-0 d-flex">
      <div class="group">
        <p class="my-0">IC Number*</p>
        <input type="text" required class="textInputLong" name="icNumber" [(ngModel)]="icNumber" (keypress)="sharedService.isNumberKey($event)" />
        <span class="highlight"></span>
        <span class="bar barLong"></span>
        @if (this.icNumber != undefined && this.sharedService.checkIfICValid(this.icNumber) == false) {
          <p class="text-danger my-1 mx-0 p-0">IC Number format invalid</p>
        }
      </div>
    </div>
    <div class="my-0 d-flex">
      <div class="group">
        <p class="my-0">Contact Number*</p>
        <input type="text" required class="textInputLong" name="contactNum" [(ngModel)]="contactNum" (keypress)="sharedService.isNumberKey($event)" />
        <span class="highlight"></span>
        <label></label>
      </div>
    </div>
    <div class="my-0">
      <div class="group">
        <p class="my-0">Relation*</p>
        <input type="text" required class="textInputLong" name="relation" [(ngModel)]="relation" />
        <span class="highlight"></span>
        <span class="bar barLong"></span>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <p class="my-0">DOB</p>
      <mat-form-field class="full-width-formField bar">
        <input matInput class="textInputLong" [matDatepicker]="myDatepicker" name="dob" [(ngModel)]="dob" placeholder="Date of Birth" onkeydown="return false;" style="border: 0px" [max]="sharedService.getTodayDate()" />
        <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #myDatepicker name="dob"></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="my-0">
      <div class="group">
        <p class="my-0">Address*</p>
        <textarea placeholder="Please fill in address" rows="3" name="address" [(ngModel)]="address"></textarea>
        <span class="highlight"></span>
        <span class="bar barLong"></span>
        <!-- <label>Address</label> -->
      </div>
    </div>

    <div class="my-0">
      <div class="group">
        <p class="my-0">Remark</p>
        <textarea placeholder="Remark" rows="3" name="remark" [(ngModel)]="remark"></textarea>
        <span class="highlight"></span>
        <span class="bar barLong"></span>
        <!-- <label>Address</label> -->
      </div>
    </div>
  </div>

  @if (isDialog == true) {
    <div class="modal-footer">
      @if (contactToUpdate != undefined) {
        <button class="btn btn-outline-success" type="button" (click)="submit()">Edit Contact</button>
      }
      @if (contactToUpdate == undefined) {
        <button class="btn btn-outline-success" type="button" (click)="submit()" [disabled]="disableSubmit">Add Contact</button>
      }
      <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
    </div>
  }
</form>
